<footer class="main-footer">
    <p class="font-14">
        Copyright © 2025 QEvalPro - All rights reserved.
    </p>
    <div class="center-align gap-2">
   <p class="font-14"> Powered by </p>
    <img src="assets/images/login-logo.png" class="d-inline-block" alt=""/>
</div>
  </footer>